__turbopack_context__.v({
  "hero": "WOdYDW_hero",
  "media": "WOdYDW_media",
});
